import store from '../store'

export function checkError(dialog, response) {
  // normalize: support either full axios response (has .data) or data-only object
  const res = (response && response.data !== undefined) ? response : { data: response };
  const data = res.data || {};

  // keep raw response in debug logs for investigation (will be removed after verification)
  console.debug('checkError 原始 response:', res);

  // body status takes precedence over HTTP status code (API returns 200 with status:"fail" in body)
  const bodyStatus = data && data.status;
  const httpStatus = res && res.status;
  const status = bodyStatus !== undefined ? bodyStatus : httpStatus;

  let msg = null;
  if (String(status).toLowerCase() === 'fail') {
    msg = (data.error && data.error.text) ? data.error.text : (data.message || '下單失敗，請稍後再試');
  }

  if (msg) {
    const meta = {
      status,
      hasErrorObject: !!data.error,
      shortResponse: {
        code: (typeof data.code !== 'undefined') ? data.code : null,
        errorCode: (data.error && typeof data.error.code !== 'undefined') ? data.error.code : null,
      },
      ts: Date.now(),
    };
    store.dispatch('error/show', { msg: msg, meta: meta });
    return false;
  }

  return true;
}
